export var mutations = {
    setFormResponses: function (state, formResponses) { return state.formResponses = formResponses; },
    setPaginationResponse: function (state, pagination) { return state.pagination = pagination; },
    setLoading: function (state, loading) { return state.loading = loading; },
    resetFormResponses: function (state) { return state.formResponses = []; },
};
export var mutationTypes = {
    SET_FORM_RESPONSES: 'setFormResponses',
    SET_PAGINATION_RESPONSE: 'setPaginationResponse',
    SET_ERROR: 'setError',
    SET_LOADING: 'setLoading',
};
